// Helpers for converting between a stored UTC instant and a naive
// "Eastern wall-clock" string (YYYY-MM-DDTHH:MM) used by the admin DateTimePicker.
// Admin scheduling (live sessions, discount expiry) is authored in ET regardless
// of the operator's browser timezone, so these convert at the form boundary.

export function utcToEastern(isoStr) {
  const d = new Date(isoStr);
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(d);
  const get = (type) => parts.find(p => p.type === type).value;
  const hour = get('hour') === '24' ? '00' : get('hour');
  return `${get('year')}-${get('month')}-${get('day')}T${hour}:${get('minute')}`;
}

export function easternToUtc(naiveStr) {
  const asUtc = new Date(naiveStr + ':00.000Z');
  const fmt = (d) => {
    const p = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(d);
    const g = (t) => p.find(x => x.type === t).value;
    const h = g('hour') === '24' ? '00' : g('hour');
    return new Date(`${g('year')}-${g('month')}-${g('day')}T${h}:${g('minute')}:00.000Z`);
  };
  const offset1 = fmt(asUtc).getTime() - asUtc.getTime();
  const guess = new Date(asUtc.getTime() - offset1);
  const offset2 = fmt(guess).getTime() - guess.getTime();
  return new Date(asUtc.getTime() - offset2).toISOString();
}
